import { Box, Button, TextField } from "@mui/material";
import React, { useState } from "react";
import regex from "../../utils/regex.js";
import { useStyles } from "./styles";

const defaultState = {
  firstName: "",
  lastName: "",
  email: "",
};

const AdminManagement = ({
  defaultData,
  edit = false,
  data = [],
  onSave,
  onClose,
}) => {
  const classes = useStyles();
  const [state, setState] = useState(defaultData || defaultState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (regex.validEmail.test(state.email)) {
      let newData = [...data];
      const compareEmail = edit ? defaultData?.email : state.email;
      const isDuplicate = newData.some((user) => user.email === compareEmail);
      if (edit || !isDuplicate) {
        if (edit) {
          const targetIndex = newData.findIndex(
            (user) => user.email === compareEmail
          );
          newData[targetIndex] = state;
        } else {
          newData.push(state);
        }
        onSave(newData);
        setState(defaultState);
      } else {
        alert("A user with this email already exists.");
      }
    }
  };

  return (
    <>
      <Box px={4}>
        <Box component="form" onSubmit={handleSubmit}>
          <TextField
            required
            margin="normal"
            fullWidth
            inputProps={{
              pattern: /^(\w*\S+)$/.source,
            }}
            name="firstName"
            label="First Name"
            value={state.firstName}
            onChange={handleChange}
          />
          <TextField
            required
            margin="normal"
            fullWidth
            inputProps={{
              pattern: /^(\w*\S+)$/.source,
            }}
            name="lastName"
            label="Last Name"
            value={state.lastName}
            onChange={handleChange}
          />
          <TextField
            required
            margin="normal"
            fullWidth
            label="Email"
            name="email"
            inputMode="email"
            type="email"
            value={state.email}
            onChange={handleChange}
          />
          <Box className={classes.footerView}>
            <Button onClick={onClose} variant="outlined" color="primary">
              Cancel
            </Button>
            <Button
              disabled={!(state.email && state.firstName && state.lastName)}
              variant="contained"
              color="primary"
              type="submit"
            >
              {edit ? "Update" : "Save"}
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default AdminManagement;
